export default __webpack_public_path__ + "static/media/pdf-glow.5512987b.svg";